import { render, staticRenderFns } from "./AlternativeResultsHint.vue?vue&type=template&id=e4ae24b4&scoped=true"
import script from "./AlternativeResultsHint.vue?vue&type=script&lang=js"
export * from "./AlternativeResultsHint.vue?vue&type=script&lang=js"
import style0 from "./AlternativeResultsHint.vue?vue&type=style&index=0&id=e4ae24b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ae24b4",
  null
  
)

export default component.exports